module.exports = __webpack_public_path__ + "static/img/contact_way.06c6b73.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/contact_way.png
// module id = 95vs
// module chunks = 1